import { render } from "./TutorialWelcomeModal.vue?vue&type=template&id=477cfb6e&scoped=true"
import script from "./TutorialWelcomeModal.vue?vue&type=script&lang=js"
export * from "./TutorialWelcomeModal.vue?vue&type=script&lang=js"

import "./TutorialWelcomeModal.vue?vue&type=style&index=0&id=477cfb6e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477cfb6e"]])

export default __exports__